import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useState } from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  boxShadow: 24,
  p: 4,
};

const Copyright = ({ mapType = 'osm' }) => {
  // osm or cadastral

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="copyright-info">
      <Button type="button" className="grid-map-switcher__button copyright-info__button" onClick={handleOpen}>
        Data Sources
      </Button>
      <Modal open={open} onClose={handleClose} className="custom-modal">
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {' '}
            {mapType === 'osm' ? (
              <a
                href="https://www.openstreetmap.org/copyright"
                className="copyright-info-link"
                target="_blank"
                rel="noreferrer"
                onClick={handleClose}
              >
                ©️ OpenStreetMap
              </a>
            ) : (
              <a
                href="https://www.swisstopo.admin.ch/en"
                className="copyright-info-link"
                target="_blank"
                rel="noreferrer"
                onClick={handleClose}
              >
                ©️ Swisstopo
              </a>
            )}
            .
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Copyright;
